import { useParams } from 'react-router-dom';

export type AdminSurveyPageParams = {
  surveyId?: string;
};

export const useAdminSurveyPageParams = () => {
  const params = useParams<AdminSurveyPageParams>();
  const surveyId = params?.surveyId ?? '';

  return { surveyId };
};
